<template>
  <div>
    <v-data-table
      :footer-props="{
        'items-per-page-text': 'Hiển thị mỗi trang',
        'items-per-page-all-text': 'Tất cả',
        'items-per-page-options': [10, 20, 50]
      }"
      :headers="headers"
      :items="dataItems"
      :loading="loading"
      :server-items-length="totalCount"
      :items-per-page="itemsPerPage"
      @update:page="val => updatePagination('page', val)"
      @update:items-per-page="val => updatePagination('itemsPerPage', val)"
      disable-sort
    >
      <template v-slot:[`body.prepend`]>
        <tr>
          <td>
            <BaseSmallInput
              placeholder="Nhập tên kho"
              v-model="filter.name_contains"
              @change="
                val => {
                  filter.name_contains = val
                  searchWithOption()
                }
              "
            />
          </td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
      </template>
      <template v-slot:[`item.users`]="{ item }">
        <div class="d-flex flex-wrap flex-column" :style="{ width: '100%' }">
          <div v-for="(i, idx) in item.users" :key="idx">
            <div class="text-ellipsis">{{ i.name }}</div>
          </div>
        </div>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-icon @click="() => onEdit(item)" color="primary">mdi-pencil</v-icon>
      </template>
    </v-data-table>
    <popupEditUserInventory ref="inventory-management" @onRefresh="onRefresh" />
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import { get } from 'lodash'
import BaseSmallInput from '../../components/basic/BaseSmallInput.vue'
import popupEditUserInventory from './popupEditUserInventory.vue'

export default {
  components: { BaseSmallInput, popupEditUserInventory },
  data() {
    return {
      page: 1,
      itemsPerPage: 10,
      get,
      totalCount: 10,
      filter: {
        name_contains: ''
      },
      headers: [
        { text: 'Kho', value: 'name', width: '20%' },
        { text: 'Tên viết tắt', value: 'name_short', width: '15%' },
        { text: 'Người quản lý', value: 'users', width: '55%' },
        { text: 'Thao tác', value: 'actions', width: '10%', align: 'center' }
      ]
    }
  },
  computed: mapState({
    dataItems(state) {
      return state['inventoryManagement'].items
    },
    loading(state) {
      return state['inventoryManagement'].loading
    }
  }),
  methods: {
    ...mapActions({
      fetchItems: 'inventoryManagement/fetchItems',
      fetchCountItems: 'inventoryManagement/countItems',
      setItemToEdit: 'inventoryManagement/setItemToEdit'
    }),
    async updatePagination(type, val) {
      const page = type === 'page' ? val : 1
      const itemsPerPage = type === 'itemsPerPage' ? val : this.itemsPerPage
      await this.fetchItems({
        _start: type === 'itemsPerPage' ? 0 : (page - 1) * itemsPerPage,
        _limit: itemsPerPage,
        ...this.filter
      })
      this.itemsPerPage = itemsPerPage
      this.page = page
    },
    async searchWithOption() {
      await this.fetchItems({ _start: 0, _limit: this.itemsPerPage, ...this.filter })
      await this.fetchCountItems({ ...this.filter })
    },
    async onRefresh() {
      await this.fetchItems({ _start: 0, _limit: this.itemsPerPage, ...this.filter })
      await this.fetchCountItems({ ...this.filter })
    },
    onEdit(data) {
      if (data.id) {
        this.setItemToEdit(data)
        this.$refs['inventory-management'].openDialog()
      }
    }
  },
  async created() {
    await this.fetchItems({ _start: 0, _limit: 10 })
    await this.fetchCountItems()
  }
}
</script>
<style lang="scss" scoped>
::v-deep {
  .v-data-table > .v-data-table__wrapper > table > tbody > tr > td,
  .v-data-table > .v-data-table__wrapper > table > tbody > tr > th,
  .v-data-table > .v-data-table__wrapper > table > thead > tr > td,
  .v-data-table > .v-data-table__wrapper > table > thead > tr > th,
  .v-data-table > .v-data-table__wrapper > table > tfoot > tr > td,
  .v-data-table > .v-data-table__wrapper > table > tfoot > tr > th {
    padding: 0 8px !important;
  }
}
td,
th {
  padding: 0 8px !important;
}
</style>
